<template>
  <div class="reg-panel">
    <div class="panel-body">
      <div class="row g-3 align-items-start">
        <!-- Columna izquierda -->
        <div class="col-8">

          <!-- Selección de carga -->
          <div class="search-box">
            <label class="field-label mb-1">Carga</label>
            <div class="d-flex gap-1">
              <button type="button" class="btn-reload" @click="cargarCargas" title="Cargar cargas">
                <span class="material-symbols-outlined" style="font-size:18px">search</span>
              </button>
              <select
                class="search-input"
                v-model="idCargaSeleccionada"
                :disabled="cargas.length === 0"
              >
                <option :value="null" disabled>— Seleccione una carga —</option>
                <option v-for="c in cargas" :key="c.idCarga" :value="c.idCarga">
                  #{{ c.secuencial }} — ({{ formatFecha(c.fechaDesde) }} / {{ formatFecha(c.fechaHasta) }}) — {{ c.nombreArchivo }}
                </option>
              </select>
            </div>
            <div class="search-status mt-1">
              <span v-if="buscandoCargas" class="text-muted">
                <span class="material-symbols-outlined spin" style="font-size:14px">progress_activity</span>
                Cargando...
              </span>
              <span v-else-if="cargas.length === 0" class="text-muted">
                Sin cargas — presione 🔍 para cargar
              </span>
              <span v-else class="text-muted">{{ cargas.length }} carga(s) disponible(s)</span>
            </div>
          </div>

          <!-- Detalle de carga seleccionada -->
          <div v-if="cargaActual" class="obs-box mt-2">
            <div class="row g-1" style="font-size:0.8rem;">
              <div class="col-6">
                <span class="text-muted">Archivo:</span>
                <strong class="ms-1">{{ cargaActual.nombreArchivo }}</strong>
              </div>
              <div class="col-3">
                <span class="text-muted">Registros:</span>
                <strong class="ms-1">{{ cargaActual.numeroRegistros }}</strong>
              </div>
              <div class="col-3">
                <span class="text-muted">Período:</span>
                <strong class="ms-1">{{ formatFecha(cargaActual.fechaDesde) }} → {{ formatFecha(cargaActual.fechaHasta) }}</strong>
              </div>
            </div>
          </div>

          <!-- Códigos -->
<!-- Códigos -->
<div class="obs-box mt-3">
  <div class="row g-2">

    <!-- Código actual -->
    <div class="col-6">
      <label class="field-label">Código actual</label>
      <div style="position:relative;">
        <div class="d-flex gap-1">
          <input
            type="text"
            class="search-input"
            v-model="filtroActual"
            placeholder="Buscar código actual..."
            @input="filtrarActual"
            @focus="mostrarDropdownActual = true; cargarItems()"
            @blur="ocultarActualConDelay"
            autocomplete="off"
          />
          <button
            v-if="codigoActual"
            type="button" class="btn-reload"
            @click="codigoActual = ''; filtroActual = ''; itemsFiltradosActual = []"
            title="Limpiar"
          >
            <span class="material-symbols-outlined" style="font-size:16px">close</span>
          </button>
        </div>
        <div v-if="mostrarDropdownActual && itemsFiltradosActual.length > 0" class="search-dropdown">
          <div
            v-for="item in itemsFiltradosActual" :key="item.idElemento"
            @mousedown="seleccionarActual(item)"
            class="dropdown-item-custom"
            :class="{ selected: codigoActual === item.elementoCodigo }"
          >
            <span class="item-code">{{ item.elementoCodigo }}</span>
            <span class="item-sep">—</span>
            <span class="item-name">{{ item.elementoNombre }}</span>
          </div>
        </div>
        <div
          v-if="mostrarDropdownActual && filtroActual && itemsFiltradosActual.length === 0 && items.length > 0"
          class="search-dropdown no-results"
        >
          Sin resultados para "{{ filtroActual }}"
        </div>
      </div>
      <small v-if="codigoActual" class="text-primary" style="font-size:0.75rem">
        ✓ {{ codigoActual }}
      </small>
    </div>

    <!-- Código nuevo -->
    <div class="col-6">
      <label class="field-label">Código nuevo</label>
      <div style="position:relative;">
        <div class="d-flex gap-1">
          <input
            type="text"
            class="search-input"
            v-model="filtroNuevo"
            placeholder="Buscar código nuevo..."
            @input="filtrarNuevo"
            @focus="mostrarDropdownNuevo = true; cargarItems()"
            @blur="ocultarNuevoConDelay"
            autocomplete="off"
          />
          <button
            v-if="codigoNuevo"
            type="button" class="btn-reload"
            @click="codigoNuevo = ''; filtroNuevo = ''; itemsFiltradosNuevo = []"
            title="Limpiar"
          >
            <span class="material-symbols-outlined" style="font-size:16px">close</span>
          </button>
        </div>
        <div v-if="mostrarDropdownNuevo && itemsFiltradosNuevo.length > 0" class="search-dropdown">
          <div
            v-for="item in itemsFiltradosNuevo" :key="item.idElemento"
            @mousedown="seleccionarNuevo(item)"
            class="dropdown-item-custom"
            :class="{ selected: codigoNuevo === item.elementoCodigo }"
          >
            <span class="item-code">{{ item.elementoCodigo }}</span>
            <span class="item-sep">—</span>
            <span class="item-name">{{ item.elementoNombre }}</span>
          </div>
        </div>
        <div
          v-if="mostrarDropdownNuevo && filtroNuevo && itemsFiltradosNuevo.length === 0 && items.length > 0"
          class="search-dropdown no-results"
        >
          Sin resultados para "{{ filtroNuevo }}"
        </div>
      </div>
      <small v-if="codigoNuevo" class="text-primary" style="font-size:0.75rem">
        ✓ {{ codigoNuevo }}
      </small>
    </div>

  </div>
  <div v-if="buscandoItems" class="search-status mt-1">
    <span class="text-muted">
      <span class="material-symbols-outlined spin" style="font-size:14px">progress_activity</span>
      Cargando elementos...
    </span>
  </div>
</div>

          <!-- Estado vacío -->
          <div v-if="!idCargaSeleccionada && !codigoActual && !codigoNuevo" class="tabla-vacia mt-3">
            <span class="material-symbols-outlined" style="font-size:28px; color:#ced4da">swap_horiz</span>
            <p class="mt-1 mb-0">Seleccione una carga e ingrese los códigos a cambiar</p>
          </div>

        </div>

        <!-- Columna derecha: resumen y acciones -->
        <div class="col-4 d-flex flex-column gap-3" style="padding-top:2rem;">
          <div v-if="idCargaSeleccionada || codigoActual || codigoNuevo" class="resumen-box">
            <div class="resumen-row">
              <span>Trámite</span>
              <strong class="text-primary">{{ idTramite }}</strong>
            </div>
            <div class="resumen-row">
              <span>Carga</span>
              <strong :class="idCargaSeleccionada ? 'text-primary' : 'text-muted'">
                {{ idCargaSeleccionada ?? '—' }}
              </strong>
            </div>
            <div class="resumen-row">
              <span>Código actual</span>
              <strong :class="codigoActual ? 'text-primary' : 'text-muted'">
                {{ codigoActual || '—' }}
              </strong>
            </div>
            <div class="resumen-row">
              <span>Código nuevo</span>
              <strong :class="codigoNuevo ? 'text-primary' : 'text-muted'">
                {{ codigoNuevo || '—' }}
              </strong>
            </div>
          </div>

          <button
            type="button" class="btn-action primary"
            @click="ejecutar"
            :disabled="!puedeEjecutar"
            title="Cambiar elemento en planilla_det"
          >
            <span class="material-symbols-outlined">swap_horiz</span>
            Cambiar código
          </button>

          <button
            type="button" class="btn-action secondary"
            @click="limpiar"
            title="Limpiar"
          >
            <span class="material-symbols-outlined">delete</span>
            Limpiar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api  from "@/services/api";
import Swal from "sweetalert2";

export default {
  name: "CambiarCodigoCarga",
  props: {
    idTramite:   { type: [Number, String], required: true },
    idPrestador: { type: [Number, String], required: true },
    idUsuario:   { type: [Number, String], required: true },
  },
  emits: ["ejecutado"],
data() {
  return {
    cargas:              [],
    buscandoCargas:      false,
    idCargaSeleccionada: null,
    // Elementos
    items:               [],
    buscandoItems:       false,
    // Código actual
    filtroActual:        "",
    itemsFiltradosActual: [],
    mostrarDropdownActual: false,
    codigoActual:        "",
    nombreActual:        "",
    // Código nuevo
    filtroNuevo:         "",
    itemsFiltradosNuevo: [],
    mostrarDropdownNuevo: false,
    codigoNuevo:         "",
    nombreNuevo:         "",
    // Prestador
    idPrestadorEfectivo: null,
  };
},
  computed: {
    cargaActual() {
      return this.cargas.find(c => c.idCarga === this.idCargaSeleccionada) ?? null;
    },
    puedeEjecutar() {
      return (
        this.idCargaSeleccionada !== null &&
        this.codigoActual.trim().length > 0 &&
        this.codigoNuevo.trim().length > 0 &&
        this.codigoActual.trim() !== this.codigoNuevo.trim()
      );
    },
  },
async mounted() {
  try {
    const res = await api.get(`/vwprestadors/${this.idPrestador}`);
    this.idPrestadorEfectivo = res.data.idPrestadorPadre ?? this.idPrestador;
  } catch {
    this.idPrestadorEfectivo = this.idPrestador;
  }
},
  methods: {
    async cargarCargas() {
      this.buscandoCargas     = true;
      this.cargas             = [];
      this.idCargaSeleccionada = null;
      try {
        const res    = await api.get(`/vwcargas/idtramite/${this.idTramite}`);
        this.cargas  = res.data;
      } catch {
        Swal.fire("Error", "No se pudo cargar las cargas del trámite", "error");
      } finally {
        this.buscandoCargas = false;
      }
    },
    formatFecha(fecha) {
      if (!fecha) return "—";
      return new Date(fecha).toLocaleDateString("es-EC", {
        year: "numeric", month: "2-digit", day: "2-digit",
      });
    },
limpiar() {
  this.idCargaSeleccionada   = null;
  this.cargas                = [];
  this.codigoActual          = "";
  this.nombreActual          = "";
  this.filtroActual          = "";
  this.itemsFiltradosActual  = [];
  this.codigoNuevo           = "";
  this.nombreNuevo           = "";
  this.filtroNuevo           = "";
  this.itemsFiltradosNuevo   = [];
},
    async ejecutar() {
      if (!this.puedeEjecutar) return;

      const confirm = await Swal.fire({
        title: "¿Confirmar cambio?",
        html:  `Se reemplazará el código <strong>${this.codigoActual}</strong>
                por <strong>${this.codigoNuevo}</strong>
                en la carga <strong>#${this.cargaActual?.secuencial}</strong>
                del trámite <strong>${this.idTramite}</strong>.`,
        icon:             "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, cambiar",
        cancelButtonText:  "Cancelar",
        confirmButtonColor: "#0d6efd",
      });
      if (!confirm.isConfirmed) return;

      try {
        await api.post("/procedimientos/cambiar-elemento-planilladet-carga", null, {
          params: {
            idTramite:      Number(this.idTramite),
            idCarga:        this.idCargaSeleccionada,
            codigo_actual:  this.codigoActual.trim(),
            codigo_nuevo:   this.codigoNuevo.trim(),
            idUsuario:      Number(this.idUsuario),
          },
        });
        Swal.fire("Éxito", "Código cambiado correctamente", "success");
        this.limpiar();
        this.$emit("ejecutado");
      } catch (e) {
        const raw = e.response?.data;
        const msg = typeof raw === "string"
          ? raw
          : raw?.message ?? raw?.error ?? e.message ?? "Error desconocido";
        Swal.fire("Error", msg, "error");
      }
    },
async cargarItems() {
  if (this.items.length > 0) return; // ya cargados
  this.buscandoItems = true;
  try {
    const res  = await api.get(`/vwtarifapress/idprestador/${this.idPrestadorEfectivo}`);
    this.items = res.data;
  } catch {
    Swal.fire("Error", "No se pudo cargar los elementos", "error");
  } finally {
    this.buscandoItems = false;
  }
},
filtrarActual() {
  if (!this.filtroActual.trim()) { this.itemsFiltradosActual = []; return; }
  const f = this.filtroActual.toLowerCase();
  this.itemsFiltradosActual = this.items.filter(i =>
    (i.elementoCodigo ?? "").toLowerCase().includes(f) ||
    (i.elementoNombre ?? "").toLowerCase().includes(f)
  ).slice(0, 50);
},
filtrarNuevo() {
  if (!this.filtroNuevo.trim()) { this.itemsFiltradosNuevo = []; return; }
  const f = this.filtroNuevo.toLowerCase();
  this.itemsFiltradosNuevo = this.items.filter(i =>
    (i.elementoCodigo ?? "").toLowerCase().includes(f) ||
    (i.elementoNombre ?? "").toLowerCase().includes(f)
  ).slice(0, 50);
},
seleccionarActual(item) {
  this.codigoActual          = item.elementoCodigo;
  this.nombreActual          = item.elementoNombre;
  this.filtroActual          = `${item.elementoCodigo} — ${item.elementoNombre}`;
  this.itemsFiltradosActual  = [];
  this.mostrarDropdownActual = false;
},
seleccionarNuevo(item) {
  this.codigoNuevo          = item.elementoCodigo;
  this.nombreNuevo          = item.elementoNombre;
  this.filtroNuevo          = `${item.elementoCodigo} — ${item.elementoNombre}`;
  this.itemsFiltradosNuevo  = [];
  this.mostrarDropdownNuevo = false;
},
ocultarActualConDelay() {
  setTimeout(() => { this.mostrarDropdownActual = false; }, 200);
},
ocultarNuevoConDelay() {
  setTimeout(() => { this.mostrarDropdownNuevo = false; }, 200);
},
  },
};
</script>

<style scoped>
.reg-panel  { background: #f8f9fa; }
.panel-body { padding: 14px 16px; }
.search-input {
  width: 100%; padding: 6px 10px; border: 1px solid #ced4da;
  border-radius: 4px; font-size: 0.85rem; transition: border-color 0.15s;
}
.search-input:focus    { outline: none; border-color: #0d6efd; box-shadow: 0 0 0 2px rgba(13,110,253,.15); }
.search-input:disabled { background: #f8f9fa; }
.btn-reload {
  display: flex; align-items: center; justify-content: center;
  padding: 6px 10px; border: 1px solid #ced4da; border-radius: 4px;
  background: #fff; cursor: pointer; color: #495057; transition: all 0.15s;
}
.btn-reload:hover { background: #0d6efd; color: #fff; border-color: #0d6efd; }
.search-status { font-size: 0.78rem; }
.obs-box {
  background: #fff; border: 1px solid #dee2e6;
  border-radius: 6px; padding: 10px 12px;
}
.tabla-vacia {
  display: flex; flex-direction: column; align-items: center;
  padding: 20px; color: #adb5bd; font-size: 0.85rem;
  border: 2px dashed #dee2e6; border-radius: 6px; background: #fff;
}
.resumen-box {
  background: #fff; border: 1px solid #dee2e6;
  border-radius: 6px; padding: 10px 12px; font-size: 0.82rem;
}
.resumen-row {
  display: flex; justify-content: space-between; padding: 2px 0; color: #495057;
}
.field-label { font-weight: 600; font-size: 0.85rem; color: #495057; display: block; margin-bottom: 4px; }
.btn-action {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 8px 14px; border: none; border-radius: 6px;
  font-size: 0.85rem; font-weight: 600; cursor: pointer;
  transition: all 0.15s; width: 100%;
}
.btn-action.primary              { background: #0d6efd; color: #fff; }
.btn-action.primary:hover:not(:disabled) { background: #0b5ed7; }
.btn-action.secondary            { background: #fff; color: #6c757d; border: 1px solid #dee2e6; }
.btn-action.secondary:hover      { background: #f8f9fa; }
.btn-action:disabled             { opacity: 0.45; cursor: not-allowed; }
@keyframes spin { to { transform: rotate(360deg); } }
.spin { display: inline-block; animation: spin 1s linear infinite; }

.search-dropdown {
  position: absolute; z-index: 1000; width: 100%;
  max-height: 220px; overflow-y: auto;
  background: #fff; border: 1px solid #ced4da;
  border-top: none; border-radius: 0 0 6px 6px;
  box-shadow: 0 6px 16px rgba(0,0,0,.12);
}
.dropdown-item-custom {
  display: flex; align-items: center; gap: 4px;
  padding: 7px 10px; cursor: pointer;
  border-bottom: 1px solid #f0f0f0; font-size: 0.82rem; transition: background 0.1s;
}
.dropdown-item-custom:hover,
.dropdown-item-custom.selected { background: #e8f0fe; }
.item-code  { font-weight: 700; color: #0d6efd; white-space: nowrap; }
.item-sep   { color: #adb5bd; margin: 0 2px; }
.item-name  { color: #343a40; flex: 1; }
.no-results { padding: 10px; font-size: 0.85rem; color: #6c757d; }
.search-status { font-size: 0.78rem; }

</style>